var svg4everybody = require('svg4everybody')
svg4everybody()